import 'bootstrap/dist/css/bootstrap.min.css';

// Simulación de productos
const productos = [
  {
    id: 1,
    nombre: 'Cámara CCTV ',
    descripcion: 'Cámaras de videovigilancia de alta calidad que cubren todas las necesidades',
    precio: '$3.200',
    imagen: '/img/products/dahua-cctv.png',
  },
  {
    id: 2,
    nombre: 'Panel de Alarma',
    descripcion: 'Panel de alarma con monitoreo 24/7',
    precio: '$1.200 / mes',
    imagen: '/img/products/axhome.png',
  },
  {
    id: 3,
    nombre: 'Alarmas de Incendios',
    descripcion: 'Detectores de humo de alta sensibilidad',
    precio: '$12.800',
    imagen: '/img/products/humo.png',
  },
  {
    id: 4,
    nombre: 'Control de Acceso Biométrico',
    descripcion: 'Lector de huellas con control de acceso integrado',
    precio: '$9.900',
    imagen: '/img/products/access.png',
  },
  {
    id: 5,
    nombre: 'Rastreo de vehiculos',
    descripcion: 'Equipa tu vehiculo con la mejor tecnologia de rastreo',
    precio: '$6.500',
    imagen: '/img/products/tracking.png',
  },
  {
    id: 6,
    nombre: 'Sensores y accesorios',
    descripcion: 'Mejora tu equipo actual con lo ultimo en seguridad',
    precio: '$1000',
    imagen: '/img/products/sensores.png',
  },
  {
    id: 7,
    nombre: 'Portones electricos',
    descripcion: 'Automatización para tu garaje: más cómodo, más seguro.',
    precio: '$1000',
    imagen: '/img/products/portones.png',
  },
  {
    id: 8,
    nombre: 'Smart Home',
    descripcion: 'Convertí tu casa en un hogar inteligente. Controlá luces, cámaras y sensores desde tu celular.',
    precio: '$1000',
    imagen: '/img/products/smarthome.png',
  },
  {
  id: 9,
  nombre: 'Conectate',
  descripcion: 'Conectividad total para tu hogar. Optimiza tu red Wi-Fi y asegurá una conexión estable entre todos tus dispositivos inteligentes.',
  precio: '$1000',
  imagen: '/img/products/conectate.png',
}

];

function Productos() {
  return (
    <>
      <h1 className="mb-4 text-white">Algunos de los productos que ofrecemos son:</h1>
      <div className="row">
        {productos.map((producto) => (
          <div key={producto.id} className="col-md-4 col-sm-6 mb-4 ">
            <div className="card h-100 shadow-sm border-warning-animated ">
              <img
                src={producto.imagen}
                className="card-img-top"
                alt={producto.nombre}
              />
              <div className="card-body d-flex flex-column justify-content-between bg-card">
                <h5 className="card-title text-white">{producto.nombre}</h5>
                <p className="card-text text-white">{producto.descripcion}</p>
                <div className="mt-auto card-btn d-flex justify-content-between align-items-center">
                  <p className="mb-0 fw-bold text-warning">Desde {producto.precio}</p>¨
                        {/* 
                  <button className="btn btn-warning btn-sm">Ver más</button>*/}
                </div>

              </div>
            </div>
          </div>
        ))}
      </div>

      <p className="mt-4 text-center text-warning">
        Estamos para ayudarte. Contactanos y recibí asesoramiento personalizado para elegir el sistema de seguridad ideal según tus necesidades.
      </p>

    </>
  );
}

export default Productos;

